import { render, staticRenderFns } from "./TractImports.vue?vue&type=template&id=6a065fed&"
import script from "./TractImports.vue?vue&type=script&lang=js&"
export * from "./TractImports.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports